import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, InputAdornment, FormControl, FormLabel, TextField } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import PropTypes from 'prop-types';
import OperatorSelect from 'src/components/common/OperatorSelect';
import ValidityAdornment from './ValidityAdornment';

const TextMassActionField = ({
  classes,
  fieldConfig,
  onChange,
  removeLine,
  onOperatorChange,
  removable,
  validity,
  isWritable,
}) => {
  const { t } = useTranslation();

  return (
    <FormControl required={fieldConfig.model.mandatory}>
      <div className={classes.fieldContainer}>
        <ValidityAdornment validity={validity} />
        <FormLabel
          style={{
            display: 'flex',
            alignItems: 'center',
            fontSize: '0.875rem',
          }}
          component="div"
        >
          {t(`smartmessaging.massAction.filterLabel.${fieldConfig.model.key}`)}
        </FormLabel>
        <div style={{ marginLeft: '16px', marginRight: '16px', display: 'flex' }}>
          <OperatorSelect
            fieldConfig={fieldConfig}
            onChange={onOperatorChange}
            disabled={!isWritable}
          />
        </div>
        <TextField
          disabled={!isWritable}
          style={{
            flex: '1',
          }}
          InputProps={{
            style: {
              fontSize: '0.875rem',
            },
          }}
          onChange={event => {
            event.preventDefault();
            onChange(fieldConfig, event.target.value);
          }}
          value={
            (fieldConfig.value &&
              fieldConfig.value.values &&
              fieldConfig.value.values.length &&
              fieldConfig.value.values[0]) ||
            ''
          }
        />
        {isWritable && removable && (
          <InputAdornment style={{ height: 'unset' }} position="start">
            <IconButton aria-label="clear" onClick={() => removeLine(fieldConfig)} size="large">
              <DeleteIcon />
            </IconButton>
          </InputAdornment>
        )}
      </div>
    </FormControl>
  );
};

TextMassActionField.propTypes = {
  classes: PropTypes.object.isRequired,
  fieldConfig: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  removeLine: PropTypes.func.isRequired,
  onOperatorChange: PropTypes.func.isRequired,
  removable: PropTypes.bool.isRequired,
  validity: PropTypes.object.isRequired,
  isWritable: PropTypes.bool.isRequired,
};

export default TextMassActionField;
